<template>
	<div class="container" v-title :data-title="menuName">
    <div class="breadcrumbs-box">
      <div class="breadcrumbs">
        <i class="el-icon-s-home home-icon"></i>
        <div class="item">
          <router-link tag="div" to="/">首页</router-link>
        </div>
        <i class="el-icon-arrow-right right-icon"></i>
        <div class="item">
          <div>{{ menuName }}</div>
        </div>
      </div>
    </div>
    <div class="container-box">
      <div class="other-news-list">
        <div class="title">
          {{ menuName }}
        </div>
        <ul class="news-box">
          <li :class="['news-item',menuActive===item.menuId?'selected':'']" v-for="item in menuList" :key="item.menuId" @click="selectMenu(item)">
            <div>{{ item.menuName }}</div>
            <div>>></div>
          </li>
        </ul>
      </div>

      <div class="news-list" v-if="curLayoutMode===1">
        <div class="title">
          {{ menuName }}
        </div>
        <ul class="news-box" v-if="newsList&&newsList.length>0">
          <!-- <li class="news-item" v-for="item in newsList" :key="item.newsNumber">
            <span class="item-title">{{ item.title }}</span>
            <span class="item-time">{{ item.createTime.split(' ')[0] }}</span>
          </li> -->
          <router-link class="news-item" tag="li" v-for="item in newsList" :key="item.newsNumber" :to="'/newsdetails?newsNumber='+item.newsNumber">
            <span class="item-title">{{ item.title }}</span>
            <span class="item-time">{{ item.createTime.split(' ')[0] }}</span>
          </router-link>
        </ul>
        <div class="news-box" v-else>
          <div class="no-data">暂无数据</div>
        </div>
        <div class="page-box">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="size"
            layout="prev, pager, next, total, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <div class="news-page" v-else-if="curLayoutMode===2">
        <div class="details-content" v-if="newsPage&&newsPage.info&&newsPage.info.content" v-html="newsPage.info.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { pageNewsList,getNewsAllInfoByMenuId } from '../../network/news'
import { getWebMenuList } from '../../network/menu'
import { saveLogFlow } from '../../network/log'

export default {
  name: "NewsList",
  data () {
    return {
      newsList: [],
      menuId: 0,
      pid: 0,
      page: 1,
      size: 10,
      total: 0,
      title: '',
      menuName: '',
      menuList: [],
      menuActive: 0,
      curLayoutMode: 1,// 1列表2单页
      newsPage: '',
      curMenu: {}
    };
  },
  props: {
    
  },
  components: {
    
  },
  mounted() {
    const params = this.$route.query;
    if(params && params.pid) {
      this.pid = Number(params.pid)
    }
    if(params && params.menuId) {
      this.menuId = Number(params.menuId)
    }
    if(this.pid) {
      this.getWebMenuList(this.pid)
    }else{
      this.getWebMenuList(this.menuId)
    }
    if(params && params.menuName) {
      this.menuName = params.menuName
      document.title = this.menuName
    }
    
    this.saveLogFlow()
  },
  beforeRouteUpdate (to, from, next) {
    // to：目标路由对象
    // from：原路由对象
    // next：可指定路由进行跳转
    next();
    this.menuId = Number(to.query.menuId)
    this.menuName = to.query.menuName
    document.title = this.menuName
    this.childMenuName = to.query.childMenuName?to.query.childMenuName:''
    this.menuActive = this.menuId
    this.curLayoutMode = Number(to.query.layoutMode)
    if(this.curLayoutMode===2){
      this.getNewsAllInfoByMenuId(this.menuId)
    }else if(this.curLayoutMode===1){
      this.pageNewsList(val.menuId,this.page,this.size,this.title)
    }

    this.saveLogFlow()
  },
  methods: {
    selectMenu(val) {
      // console.log(val)
      this.menuActive = val.menuId
      this.curLayoutMode = val.layoutMode
      // console.log('列表形式',this.curLayoutMode)
      if(this.curLayoutMode===2){
        this.getNewsAllInfoByMenuId(val.menuId)
      }else if(this.curLayoutMode===1){
        this.pageNewsList(val.menuId,this.page,this.size,this.title)
      }
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageNewsList(this.menuId,this.page,this.size,this.title)
    },
    // 网络请求
    pageNewsList(menuId,page,size,title) {
      pageNewsList(menuId,page,size,title).then(res=>{
        if(res.status===200&&res.data) {
          this.newsList = res.data
          this.total = res.total
          // console.log('新闻页列表',this.newsList)
        }
      })
    },
    getNewsAllInfoByMenuId(menuId) {
      getNewsAllInfoByMenuId(menuId).then(res=>{
        if(res.status===200&&res.data) {
          this.newsPage = res.data
          // console.log('新闻单页',this.newsPage)
        }
      })
    },
    getWebMenuList(menuId) {
      getWebMenuList(menuId).then(res=>{
        if(res.status===200&&res.data) {
          if(res.data.length>0) {
            this.menuList = res.data
            this.menuActive = this.menuId
            if(!this.pid) {
              this.menuActive = this.menuList[0].menuId
              this.curLayoutMode = this.menuList[0].layoutMode
            }else{
              
              let curMenuList = this.menuList.filter(item=>{
                return item.menuId === this.menuId
              })

              if(curMenuList.length>0) {
                this.curMenu = curMenuList[0]
              }
              this.curLayoutMode = this.curMenu.layoutMode
            }
            if(this.curLayoutMode===2){
              this.getNewsAllInfoByMenuId(this.curMenu.menuId)
            }else if(this.curLayoutMode===1){
              this.pageNewsList(this.menuId,this.page,this.size,this.title)
            }

            // console.log('当前菜单',this.curMenu)
            // console.log('列表形式',this.curLayoutMode)
            // console.log('菜单列表',this.menuList)
          }else{
            this.curLayoutMode = 2
            this.getNewsAllInfoByMenuId(this.menuId)
          }
        }
      })
    },
    saveLogFlow() {
      saveLogFlow().then(res=>{
        if(res.status===200&&res.data) {
          // console.log(res.data)
        }
      })
    }
  }
}
</script>

<style scoped>
  .details-content>>>img {
    max-width: 100%;
    margin: 10px 0;
  }
  .details-content>>>a {
    color: #0B5EA4 !important;
    text-decoration: underline !important;
    cursor: pointer !important;
  }
  .details-content>>>a span {
    color: #0B5EA4 !important;
  }
</style>
<style lang='less' scoped>
.container {
  width: 100%;
  .breadcrumbs-box {
    width: 100%;
    height: 40px;
    background-color: #eee;
    .breadcrumbs {
      width: 1200px;
      height: 40px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .home-icon {
        color: var(--theme-text-color);
        font-size: 14px;
      }
      .right {
        color: #535353;
        font-size: 14px;
      }
      .item {
        margin-left: 10px;
        font-size: 14px;
        color: #535353;
        cursor: pointer;
      }
    }
  }
  .container-box {
    width: 1200px;
    margin: 20px auto 35px;
    display: flex;
    justify-content: space-between;
    .news-list {
      width: 870px;
      .title {
        width: 100%;
        font-size: 18px;
        color: #313131;
        font-weight: bold;
        border-bottom: 1px solid #7d7d7d;
        padding: 10px 0;
        position: relative;
        &::after {
          content: "";
          display: inline-block;
          width: 74px;
          height: 6px;
          background-color: var(--theme-color);
          position: absolute;
          left: 0;
          bottom: -3px;
        }
      }
      .news-box {
        padding-top: 12px;
        .no-data {
          color: #999;
          font-size: 14px;
          text-align: center;
          padding: 10px 0;
        }
        .news-item {
          padding: 0 20px;
          height: 40px;
          line-height: 40px;
          border-bottom: 1px dashed #d2d2d2;
          list-style-type: none;
          padding-left: 20px;
          color: #1b1b1b;
          font-size: 16px;
          cursor: pointer;
          position: relative;
          display: flex;

          &::before {
            content: "";
            display: inline-block;
            width: 5px;
            height: 5px;
            background-color: #1b1b1b;
            rotate: 45deg;
            margin-right: 10px;
            position: absolute;
            left: 5px;
            top: 50%;
            transform: translateY(-50%);
          }
          .item-title {
            flex: 1;
          }
          .time {
            width: 71px;
          }
        }
      }
      .page-box {
        padding-top: 60px;
        text-align: center;
      }
    }
    .news-page {
      width: 870px;
      padding: 35px;
      // display: none;
      .details-content {
        width: 100% ;
        line-height: 2;
      }
    }
    .other-news-list {
      width: 310px;
      .title {
        border-top: 10px solid var(--theme-color);
        background-color: #eee;
        height: 90px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 34px;
        font-size: 20px;
        font-weight: bold;
        color: var(--theme-text-color);
        .right-icon {
          color: var(--theme-text-color);
        }
      }
      .news-box {
        border-bottom: 80px solid #e5e5e5;
        .news-item {
          padding: 0 20px;
          height: 49px;
          line-height: 49px;
          list-style-type: none;
          padding-left: 20px;
          color: #1b1b1b;
          font-size: 16px;
          cursor: pointer;
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border: 1px solid #e5e5e5;
          &.selected {
            background-color: var(--theme-color);
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
